<div class="row" (window:resize)="onResize()" #gaugeContainer>
  <div class="col-lg-12 col-md-12 col-sm-12" id="chartdiv" style="width: 100%; height: 340px" ></div>
  <div class="col-lg-12 col-md-12 col-sm-12">
    <p class="gauge-explanation">
      <strong>Variation de {{gauge.diff_percent > 0 ? '+' : ''}}{{gauge.diff_percent}}%</strong> de votre consommation d’énergie
    </p>
  </div>
</div>
